import type { TagBulkChargeFamilyPreview } from '~entities/payment/api/bulk-charge-by-tags';

import { Badge } from '~shared/shadcn/ui/badge';

interface TagFamilyConfirmationStepProps {
  families: Array<TagBulkChargeFamilyPreview>;
}

export function TagFamilyConfirmationStep({
  families,
}: TagFamilyConfirmationStepProps) {
  return (
    <div className='space-y-4'>
      <p className='text-sm text-muted-foreground'>
        {families.length} famil{families.length === 1 ? 'y' : 'ies'} will be
        charged once each (even with multiple students).
      </p>
      <div className='max-h-[360px] space-y-3 overflow-y-auto'>
        {families.map((family) => (
          <div key={family.parentId} className='rounded-md border p-3'>
            <div className='flex flex-wrap items-center justify-between gap-2'>
              <div>
                <div className='font-medium'>{family.parentName}</div>
                <div className='text-sm text-muted-foreground'>
                  {family.parentEmail || 'No email'}
                </div>
              </div>
              <div className='flex flex-wrap gap-2'>
                <Badge variant={family.hasActiveStudent ? 'default' : 'secondary'}>
                  {family.hasActiveStudent ? 'Active enrollment' : 'No active'}
                </Badge>
                <Badge
                  variant={
                    family.hasPaymentMethodOnFile ? 'default' : 'outline'
                  }
                >
                  {family.hasPaymentMethodOnFile
                    ? 'Payment method'
                    : 'Balance due if charged'}
                </Badge>
              </div>
            </div>
            <div className='mt-2 text-sm'>
              Students: {family.studentNames.join(', ')}
            </div>
            <div className='mt-2 flex flex-wrap gap-1'>
              {family.matchedTags.map((tag) => (
                <Badge key={`${tag.source}-${tag.id}`} variant='outline'>
                  {tag.name} ({tag.source === 'contact' ? 'CRM' : 'Class'})
                </Badge>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
